import React from 'react'
import Cards from "../../Assets/images/cards.png";
import './Footer.css';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();
  return (
    <div className='footer_section text-center'>
      <img src={Cards} alt='cards' />
      <p> Copyright 2016-{currentYear} @climaxdigitizing.com | Terms & Conditions</p>
    </div>
  )
}

export default Footer